export default __webpack_public_path__ + "static/jireh1-7e2f589e505513a8790843baa8b589cc.jpg";